<template>
  <div class="order">
    <Header title="提货申请详情"></Header>
    <div class="order-detail">
      <OrderInfoCardDetail :order="orderData" :productData="productData"></OrderInfoCardDetail>
      <OrderCommodityCard
        :orderDetail="productData"
        :advanceSalePlanInfo="advanceSalePlanInfo"
      ></OrderCommodityCard>
      <OrderDeliveryTypeCard :orderDetail="productData"></OrderDeliveryTypeCard>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import OrderInfoCardDetail from "./components/OrderInfoCardDetail";
import OrderCommodityCard from "./components/OrderCommodityCard";
import OrderDeliveryTypeCard from "./components/OrderDeliveryTypeCard";
import orderApi from "@/request/orderApi";
export default {
  name: "PickupDetail",
  components: {
    Header,
    OrderInfoCardDetail,
    OrderCommodityCard,
    OrderDeliveryTypeCard,
  },
  data() {
    return {
      deliveryMode2: "",
      constants: this.$common.interfacePath,
      canSubmit: false,
      agreementChecked: [],
      currentStep: 0,
      advanceSalePlanInfo: {}, //月计划量
      form: {
        remark: "",
        ifDepositToPayment: "1",
        deliveryMode: "1",
        deliveryAddress: "",
      },
      contractInfo: {
        contractNo: "",
        price: "",
        totalWeight: "",
        executedWeight: "",
        validDateBegin: "",
        validDateEnd: "",
      },
      copartnerInfo: {}, //之前取值有问题最新开票信息
      invoiceInfo: {}, //开票信息
      concessionDetailList: [], //优惠信息

      formInit: {
        orderType: [],
        priceType: [
          {
            itemCode: "02",
            itemName: "定价",
          },
          {
            itemCode: "01",
            itemName: "挂牌",
          },
        ],
        sendType: [
          {
            itemCode: "Z",
            itemName: "直发",
          },
          {
            itemCode: "K",
            itemName: "库发",
          },
          {
            itemCode: "D",
            itemName: "断卖",
          },
        ],
        deliveryType: [
          {
            itemCode: "1",
            itemName: "自提",
          },
          {
            itemCode: "2",
            itemName: "配送",
          },
        ],
        status: [
          //订单状态
          {
            itemName: "已撤销",
            itemCode: "-1",
          },
          {
            itemName: "待提交",
            itemCode: "0",
          },
          {
            itemName: "待确认",
            itemCode: "0_1", //其他交易模式
          },
          {
            itemName: "待确认",
            itemCode: "0_2", //待客户下单
          },
          {
            itemName: "待确认",
            itemCode: "0_3", //业务员初审之后再确认
          },
          {
            itemName: "待审核",
            itemCode: "1",
          },
          {
            itemName: "审核中",
            itemCode: "2",
          },
          {
            itemName: "待发货",
            itemCode: "3",
          },
          {
            itemName: "发货中",
            itemCode: "4",
          },
          {
            itemName: "已完成",
            itemCode: "9",
          },
        ],
      },
      single: false,
      orderData: {}, //详情数据
      productData: {}, //商品详情
      deliveryAddressConfigOption: [], //配送地址
    };
  },
  mounted() {
    this.getOrderdetail();
  },
  computed: {
    statusName() {
      let statusName;
      switch (this.orderData.status) {
        case "1":
          statusName = "待审核，请等待审核";
          break;
        case "2":
          statusName = "审核中,请等待审核";
          break;
        case "3":
          statusName = "已审批通过，待发货";
          break;
        case "4":
          statusName = "发货中";
          break;
        case "9":
          statusName = "已完成，待评价";
          break;
        case "0_1":
          statusName = "待确认，请确认";
          break;
        case "0_2":
          statusName = "待确认，请确认";
          break;
        case "0_3":
          statusName = "待确认，请确认";
          break;
        case "0_4":
          statusName = "待审核，请等待审核";
          break;
        case "-1":
          statusName = "已取消";
          break;
        case "2_2":
          statusName = "审核中，请等待审核";
          break;
        case "1_1":
          statusName = "待审核，请等待审核！";
          break;
      }
      return statusName;
    },
  },
  methods: {
    // 获取到详情
    getOrderdetail() {
      let params = {
        id: this.$route.query.id,
      };
      orderApi.orderDetail(params).then((res) => {
        if (res.returnCode == "0") {
          this.orderData = res.result;
          // this.setCurrentStep(res.result.status);
          this.productData = res.result.orderDetailInfoList[0];
          console.log(this.productData);
          this.copartnerInfo = res.result.copartnerInfo;
          this.invoiceInfo = res.result.invoiceInfo;
          this.advanceSalePlanInfo = res.result.advanceSalePlanInfo;
          this.concessionDetailList = res.result.concessionDetailList;
          this.deliveryAddressConfigOption =
            res.result.deliveryAddressConfigOption;
          this.deliveryMode2 =
            res.result.orderDetailInfoList[0] &&
            res.result.orderDetailInfoList[0].deliveryMode;

          this.form.ifDepositToPayment =
            this.form.ifDepositToPayment == null
              ? "1"
              : this.form.ifDepositToPayment;

          this.canSubmit =
            res.result.status == "0_1" ||
            res.result.status == "0_2" ||
            res.result.status == "0_3";

          console.log("canSubmit", this.canSubmit);
          let self = this;
          res.result.agreementSignList.forEach(function (item, index) {
            if (item.signed == "1") {
              self.agreementChecked.push(index);
            }
          });
          this.orderData.agreementSignList = res.result.agreementSignList;
          console.log("p,mkklk", this.orderData.agreementSignList);
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    //查看协议
    viewAgreement(agreementType, templateId) {
      this.$refs.Agreement.viewAgreement(agreementType, templateId);
    },
    // viewAgreement(agreementType, templateId) {
    //   console.log(agreementType, templateId);
    //   this.$router.push({
    //     path: "/viewAgreement",
    //     query: {
    //       agreementType,
    //       templateId,

    //     this.$toast({
    //       type: "fail",
    //       message: res.returnMessage,
    //       duration: 1500,
    //     });
    //   }
    // },
    submitConfirm() {
      let self = this;
      let agreementCheck = true;
      this.orderData.agreementSignList.forEach(function (item, index) {
        if (
          item.mustAgreeFlag == "1" &&
          self.agreementChecked.find((item2) => item2 == index) == null
        ) {
          //必须同意的协议
          agreementCheck = false;
          return self.$toast.fail("请阅读并同意" + item.agreementName);
        }
        console.log(
          "88888",
          self.agreementChecked.find((item2) => item2 == index)
        );
        console.log(
          "000",
          self.agreementChecked.find((item2) => item2 == index)
        );
      });

      if (!agreementCheck) {
        return;
      }

      let agreementSignListParam = [];
      self.agreementChecked.forEach((item) =>
        agreementSignListParam.push(this.orderData.agreementSignList[item])
      );
      console.log("0000", agreementSignListParam);

      let params = {
        orderId: this.$route.query.id,
        operate: "1",
        ifDepositToPayment: this.form.ifDepositToPayment,
        remark: this.form.remark,
        agreementSignList: agreementSignListParam,
        deliveryMode: this.form.deliveryMode,
        deliveryAddress: this.form.deliveryAddress,
      };
      orderApi.recheckOrder(params).then((res) => {
        if (res.returnCode == "0") {
          this.$toast.success("确认订单成功");
          history.back();
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    goComment(val) {
      // this.$refs.orderComment.show();
      this.appraise = {
        evaluateInfo: "", //评价信息
        expertCode: "", //专家编号
        expertSrvId: "", //主键id
        createUserId: "", //申请人id
      };
      this.appraise.evaluateInfo = val.evaluateInfo;
      this.appraise.expertCode = val.expertCode;
      this.appraise.expertSrvId = val.expertSrvId;
      this.appraise.createUserId = val.createUserId;
      this.$router.push({
        path: "/comment",
        query: this.appraise,
      });
    },
    viewComment() {
      // this.$refs.orderComment.viewComment();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.agreement >>> .van-checkbox__icon {
  display: inline-block;
}

.order {
  display: flex;
  flex-direction: column;
  height: 100%;

  .order-detail {
    flex: 1;
    height: 91vh;
    position: absolute;
    padding: 0 20px;
    top: 0.88rem;
    left: 0;
    right: 0;
    // bottom: 0.88rem;
    font-size: 28px;
    overflow: auto;
  }
}

.order >>> .van-cell {
  font-size: 26px;
  line-height: 49px;
  border: 1PX solid rgba(153, 153, 153, 1);
  border-radius: 10px;
}

.order-status {
  // width: 100%;
  height: 88px;
  line-height: 88px;
  // vertical-align center
  padding: 0 40px;
  background: #ffffff;
  color: #E12020;
  font-size: 36px;
}

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line {
      line-height: 54px;
    }
  }
}

.agreement >>>.van-checkbox {
  .van-checkbox__icon {
    font-size: 26px;
    line-height: 37px;
  }

  .van-checkbox__label {
    height: 37px;
    font-size: 26px;
    font-weight: 400;
    line-height: 37px;
    color: rgba(225, 32, 32, 1);
    opacity: 1;
  }
}

.agreement {
  display: flex;
  height: 84px;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;

  // font-size: 26px;
  .link {
    height: 37px;
    font-size: 26px;
    font-weight: 400;
    line-height: 37px;
    color: rgba(58, 112, 204, 1);
    text-decoration: underline;
    opacity: 1;
  }
}

.bottom-btn {
  background: #FFFFFF;
  height: 88px;
  position: absolute;
  text-align: center;
  bottom: 0;
  width: 100%;
  line-height: 88px;

  .submit-btn {
    width: 50%;
    height: 80px;
    background: linear-gradient(132deg, rgba(239, 150, 35, 1) 0%, rgba(225, 32, 32, 1) 100%);
    opacity: 1;
    border-radius: 40px;
    font-size: 34px;
    color: #FFFFFF;
  }
}
</style>